import { useLanguagePreference } from "@hooks:useLanguagePreference";
import i18n, { isSupportedLanguage } from "@libs:i18n";
import { useEffect } from "react";

/**
 * Applies the signed-in user's saved language preference to i18next.
 */
export const LanguageSync = () => {
  const { language } = useLanguagePreference();

  useEffect(() => {
    if (isSupportedLanguage(language) && language !== i18n.resolvedLanguage) {
      i18n.changeLanguage(language);
    }
  }, [language]);

  return null;
};
